<template>
  <el-dialog title="Alterar Renovação do Contrato de Aluguel" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="350px">
    <el-form :model="form"
      :rules="validacao" 
      ref="form" 
      size="small" 
      label-position="top" 
      hide-required-asterisk	
      :show-message="false" style="padding:0;"
    >

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Cancelar renovação a partir do mês série" prop="ultimoMesSerieRenovacaoAnterior">
            <el-input v-model="form.ultimoMesSerieRenovacaoAnterior" v-mask="'###'" placeholder="Mês série"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="alterar" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      form: {
        ultimoMesSerieRenovacaoAnterior: undefined
      },

      validacao: {
        ultimoMesSerieRenovacaoAnterior: [{ required: true }]
      }
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
      'alterarRenovacaoAluguel'
    ]),
    iniciar() {
      this.form.ultimoMesSerieRenovacaoAnterior = undefined
    },
    alterar() {
      this.$refs["form"].validate(valid => {
        const formIsInvalid = !valid;
        if(formIsInvalid) {
          this.$message.warning("Insira os dados obrigatórios.");
          return;
        }
          let payload = {
            id: this.aluguel.id,
            ultimoMesSerieRenovacaoAnterior: this.form.ultimoMesSerieRenovacaoAnterior
          }

          this.showLoading();
              this.alterarRenovacaoAluguel(payload)
              .then((resultado) => {
                this.hideLoading();
                switch(resultado.status) {
                  case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    break;
                  default:
                    this.$message.warning(resultado.mensagem);
                    break;
                }
                this.fechar();
              }).catch(() => {
                this.fechar();
                this.hideLoading();
              });
      });
    },
    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
